import { useSocureBaseLogic } from '@Hooks/socure/useSocureBaseLogic';
import { useBoundStore } from '@Store/useBoundStore';
import { useUboDocVStatusPolling } from './useUboDocVStatusPolling';
import { useResendUboDocV } from './useResendUboDocV';
import type { SocureLogicHookResult } from '@Pages/happyFlowPages/NonUsSocure/NonUSSocurePage';

export const useUboDocVLogic = (): SocureLogicHookResult => {
  const customerId = useBoundStore((state) => state.secondaryCustomerId!);

  const {
    refetch: resendDocV,
    isFetching: isSendingResend,
    data: resendData,
  } = useResendUboDocV(customerId);

  const {
    openResendOption,
    isSuccessNotificationVisible,
    setIsSuccessNotificationVisible,
    errorMessage,
    timeLeft,
    onSendSmsClick,
    isLoadingSms,
  } = useSocureBaseLogic({
    resendDocVFn: resendDocV,
    isSending: isSendingResend,
  });

  useUboDocVStatusPolling({ customerId });

  return {
    onSendSmsClick,
    openResendOption,
    timeLeft,
    isLoading: isLoadingSms,
    errorMessage,
    socureQR: resendData?.qrCode,
    isSuccessNotificationVisible,
    setIsSuccessNotificationVisible,
  };
};
